/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface Perturbation
 */
export interface Perturbation {
  /**
   *
   * @type {number}
   * @memberof Perturbation
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof Perturbation
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Perturbation
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof Perturbation
   */
  description: string;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof Perturbation
   */
  taskType: TaskTypeEnum;
}

/**
 * Check if a given object implements the Perturbation interface.
 */
export function instanceOfPerturbation(value: object): value is Perturbation {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('displayName' in value) || value['displayName'] === undefined) return false;
  if (!('description' in value) || value['description'] === undefined) return false;
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  return true;
}

export function PerturbationFromJSON(json: any): Perturbation {
  return PerturbationFromJSONTyped(json, false);
}

export function PerturbationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Perturbation {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    displayName: json['display_name'],
    description: json['description'],
    taskType: TaskTypeEnumFromJSON(json['task_type']),
  };
}

export function PerturbationToJSON(value?: Omit<Perturbation, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    display_name: value['displayName'],
    description: value['description'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
  };
}
